import React, {Component} from 'react'
import ClientSideCacheController from '../ClientSideCacheController'
import Toggle from '../Toggle'
import OutsideScriptManager from '../OutsideScriptManager';
const USGSKMLDATASOURCE = 'https://earthquake.usgs.gov/fdsnws/event/1/query?format=kml&minmagnitude=0&minlongitude=-103&maxlongitude=-94&maxlatitude=37&minlatitude=33&starttime='
const USGSGEOJSONDATASOURCE = 'https://earthquake.usgs.gov/fdsnws/event/1/query?format=geojson&minmagnitude=2.5&minlongitude=-103&maxlongitude=-94&maxlatitude=37&minlatitude=33&starttime='

/* Documentation of query: https://earthquake.usgs.gov/fdsnws/event/1/ */
/* This is an oddball module that is not pure react. Keep a close eye on this.state.earthquakes vs this.earthquakes
this.earthquakes is the basis for all the maps features, and this.state.earthquakes only renders to the list on the right
this is becuase Google Maps Does NOT play well when this.setMap(null) is used in the render method. FOr some reason,
it cannot remove the heatMap from the DOM in the render function, which caused the heatMap layers to 'pile up'. The only way around
was to un-reactify the Google Map features. They are all handled in callbacks and traditional order of operations. */
class EarthquakeMap extends Component {
  constructor(props) {
    super(props)
    this.map = false
    this.heatMap = null
    this.heatMapData = null
    this.googleScriptPromise = null
    this.USGSGeoJsonDataPromise = null
    this.USGSGeoJsonData = null
    this.circleFillColor = '#BE0000'
    this.circleFillOpacity = 0.4
    this.heatMapAlreadySet = false
    this.defaultCenter = {
      lat: 36.300332,
      lng: -97.348378
    }

    this.showHeatMap = true

    this.state = {
      earthquakes: [],
      daysAgo: 60,
      minimumMagnitude: 2
    }

  }

  componentWillMount() {

    if (typeof window === 'object') {


      this.USGSGeoJsonDataPromise = this.Ajax(USGSGEOJSONDATASOURCE + this.getStartTime()).then((data) => {
        this.USGSGeoJsonData = JSON.parse(data)
        return this.USGSGeoJsonData
      })
    }

  }

  componentDidMount() {
    OutsideScriptManager.load('googleMaps').then(this.initMap)
    //this.googleScriptPromise.then(this.initMap)
  }

  initMap = () => {
    this.map = new google.maps.Map(document.getElementsByClassName('map')[0], {
      center: this.defaultCenter,
      zoom: 8
    });
    this.USGSGeoJsonDataPromise.then(this.buildEarthquakes)
    //code for KML layer from USGS
    // var ctaLayer = new google.maps.KmlLayer({
    //   url: USGSKMLDATASOURCE + this.getStartTime(),
    //   map: this.map,
    //   preserveViewport: true
    // });
  }

  buildHeatMap = () => { //ony from those shown

    if (this.heatMap) {
      this.heatMap.setMap(null)
      delete this.heatMap
    }
    this.heatMap = new google.maps.visualization.HeatmapLayer({
      data: this.earthquakes.filter(function(e) {
        return e.showMarker
      }),
      radius: 30,
      dissipating: true
    });

    if (this.showHeatMap)
      this.heatMap.setMap(this.map)

  }

  centerMap = () => {
    ClientSideCacheController.getGeoLocation((pos) => {
      if (pos) {
        this.map.setCenter(pos);
        this.map.setZoom(9)
      }

    })
  }

  buildEarthquakes = () => {
    var features = this.USGSGeoJsonData.features
    this.setState({earthquakes: []})
    var earthquakes = features.map((f, i, a) => {
      var earthquake = {
        magnitude: f.properties.mag,
        timeStamp: f.properties.time,
        date: new Date(f.properties.time),
        title: f.properties.title,
        place: f.properties.place,
        modifiedMercalliIntensity: f.properties.cdi,
        showWindow: false,
        showMarker: true,
        felt: f.properties.felt,
        location: new google.maps.LatLng(f.geometry.coordinates[1], f.geometry.coordinates[0]),
        weight: Math.sqrt(Math.pow(10, f.properties.mag + 1))
      }
      earthquake.position = {
        lat: f.geometry.coordinates[1],
        lng: f.geometry.coordinates[0]
      }

      earthquake.marker = new google.maps.Circle({

        strokeOpacity: 0,
        strokeWeight: 2,
        fillColor: this.circleFillColor,
        fillOpacity: this.circleFillOpacity,

        center: earthquake.location,
        radius: earthquake.weight
      });
      earthquake.infoWindow = new google.maps.InfoWindow({content: this.infoWindow(earthquake), position: earthquake.location})

      return earthquake
    })

    earthquakes.sort(function(a, b) {
      return a.magnitude < b.magnitude
        ? -1
        : 1
    })
    this.earthquakes = earthquakes
    this.filterEarthquakes() //also shows them
    this.earthquakes.map((e, i, a) => {
      e.marker.addListener('click', () => {

        this.clickMarker(e, i)
      });
    })
    //  this.buildHeatMap()

  }

  showSomeMarkers = () => {
    this.earthquakes.map((e, i, a) => {
      if (e.showMarker)
        e.marker.setMap(this.map)
      else
        e.marker.setMap(null)
    })
  }

  closeAllInfoWindows = () => {
    this.earthquakes.map(function(e) {
      e.infoWindow.close()
    })
  }

  clickMarker = (e, i) => {
    this.map.setZoom(
      this.map.getZoom() > 10
      ? this.map.getZoom()
      : 10);
    this.map.setCenter(e.location);
    this.closeAllInfoWindows()
    e.infoWindow.open(this.map)

  }

  infoWindow(e) {

    return `<div class='info-window'>
              <div>${e.place}</div>
              <div>${e.magnitude} Magnitude</div>
            </div>
            `
  }

  getStartTime = () => {
    var a = new Date
    a = new Date(a.setDate(a.getDate() - this.state.daysAgo))
    var b = a.getFullYear()
    var d = a.getMonth() + 1
    a = a.getDate();
    return b + "-" + (
      10 > d
      ? "0" + d
      : d) + "-" + (
      10 > a
      ? "0" + a
      : a)
  }

  Ajax(url) {
    return new Promise(function(resolve, reject) {
      let req = new XMLHttpRequest();
      req.open('GET', url);
      req.onload = function() {
        if (req.status === 200) {
          resolve(req.response);
        } else {
          reject(new Error(req.statusText));
        }
      };
      req.onerror = function() {
        reject(new Error('Network error'));
      };
      req.send();
    });
  }

  toggleHeatMap = (checked) => {
    this.showHeatMap = !!checked

    this.buildHeatMap()
  }

  filterEarthquakes = () => {
    var earthquakes = this.earthquakes.map((e) => {
      var earthquake = e
      if (e.magnitude <= this.state.minimumMagnitude) {
        earthquake.showMarker = false
        return earthquake
      }

      if (e.timeStamp <= Date.now() - this.state.daysAgo * 60 * 60 * 24 * 1000) {
        earthquake.showMarker = false
        return earthquake
      }
      earthquake.showMarker = true
      earthquake.showWindow = false
      return earthquake
    })
    this.showSomeMarkers()
    this.setState({earthquakes: earthquakes}) //this is only for the list
    this.buildHeatMap()
  }

  render() {

    return (<div className='gnm-earthquakemap'>
      <div className="row no-gutter">
        <div className='col-md-9'>
          <div className='map'></div>
        </div>
        <div className="col-md-3 map-height overflow-scroll">
          <div className='legend'>

            <div>
              <button type="button" className="btn btn-primary" onClick={this.centerMap}>
                <h6>Center Map
                  <span className="fa fa-crosshairs"></span>
                </h6>
              </button>
            </div>
            <div className='toggles'>
              <Toggle default={true} handler={this.toggleHeatMap}>Show Heat Map</Toggle>
              <label name="daysAgo" className='range-title'>Last {this.state.daysAgo} Days</label>
              <input type="range" name="daysAgo" min='1' max='60' step='1' value={this.state.daysAgo} onChange={(e) => {
                  console.log('changed daysAgo')

                  this.setState({
                    daysAgo: e.target.value
                  }, this.filterEarthquakes)

                }}/>
              <label name="magnitude" className='range-title'>Minimum {this.state.minimumMagnitude} Magnitude</label>
              <input name='magnitude' className='over' type="range" min='2' max='7' defaultValue='0' onChange={(e) => {
                  this.setState({
                    minimumMagnitude: e.target.value
                  }, this.filterEarthquakes)
                }}/>
            </div>
          </div>
          <ul className='list'>
            {
              this.state.earthquakes.sort(function(a, b) {
                return a.timeStamp > b.timeStamp
                  ? -1
                  : 1
              }).filter(function(e) {
                return e.showMarker
              }).map((e, i, a) => {
                return (<li key={i} onClick={() => {
                    this.clickMarker(e, i)
                  }} className={i % 2 === 0
                    ? 'light'
                    : 'dark'}>
                  <h6>
                    <span className='fa fa-bullseye'></span>
                    <span>{e.magnitude}</span>
                    <span> Magnitude</span>
                  </h6>
                  <div className='sixteen-font'>{e.title}</div>
                  <div className='forteen-font'>{e.felt || 0} {e.felt == 1 ? 'person':'people'} reported this quake</div>
                  <div className=' date'>{e.date.toLocaleString()}</div>
                </li>)
              })
            }
          </ul>
        </div>
      </div>

    </div>)
  }
}

export default EarthquakeMap



// WEBPACK FOOTER //
// ./app/components/custom/ssr/EarthquakeMap/index.js